module.exports = __webpack_public_path__ + "img/scene-6.5eeff131.png";